"use client";

import { CompanyIcon } from "@/components/icons";
import { cn } from "@/lib/utils";
import AuthSplitLayout from "./components/AuthSplitLayout";
import AuthSupportFooter from "./components/AuthSupportFooter";
import LoginForm from "./components/LoginForm";

const Login = () => {
  return (
    <AuthSplitLayout imageAlt="Fixrli login illustration">
      <div
        className={cn(
          "w-full max-w-[519px] space-y-4 sm:space-y-5 md:space-y-6",
        )}
      >
        <div
          className={cn(
            "-mt-3 flex flex-col gap-2 sm:gap-3 pb-4 border-b border-[var(--gray-200)]",
          )}
        >
          <div className={cn("flex items-start gap-2 sm:gap-3")}>
            <div
              className={cn(
                "flex items-center justify-center shrink-0 w-12 h-12 sm:w-14 sm:h-14 rounded-xl p-2 bg-[var(--blue-500)]",
              )}
            >
              <CompanyIcon />
            </div>
            <div className={cn("min-w-0")}>
              <h1
                className={cn(
                  "text-2xl sm:text-3xl font-medium tracking-[-0.04em] text-[var(--gray-900)]",
                )}
              >
                Welcome to Fixrli
              </h1>
              <p
                className={cn(
                  "text-sm sm:text-base font-normal mt-0 leading-[1.75] tracking-[-0.02em] text-[var(--gray-800)]",
                )}
              >
                Sign in or register as new account to grow your business.
              </p>
            </div>
          </div>
        </div>

        <LoginForm />

        <AuthSupportFooter className={cn("!mt-6")} />
      </div>
    </AuthSplitLayout>
  );
};

export default Login;
